export default "__VITE_ASSET__aFLTVGCC__"